import axios from "axios";
import { Config } from "../Common/Config";

export const spacerData =async ( apiName ,payload,url, isProtected = true)=>{
    return new Promise(async (resolve, reject) => {
        try {
            // console.log('spacerData ::::', payload)
            // const response = await axios.get(`${Config.url}${apiName}`,{data : payload}, {
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': `Bearer ${localStorage.getItem('token')}`
            //     }
            // });

            const baseUrl = isProtected ? Config.url : Config.urlOpen;
            // console.log('Open API URL:', Config.urlOpen);
                  // Build headers conditionally
            const headers = {
                'Content-Type': 'application/json',
                ...(isProtected && {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
                })
            };

            const response = await axios.get(`${baseUrl}${apiName}`, {
                headers,
                params: payload // Correct for GET requests
              });

            // const response = await axios.get(`${Config.url}${apiName}`, {
            //     headers: {
            //       'Content-Type': 'application/json',
            //       'Authorization': `Bearer ${localStorage.getItem('token')}`
            //     },
            //     params: payload // ← Use this instead of `data` for GET
            //   });
              
              
              
            
            resolve(response)
        } catch (error) {
            console.log('error in get clinic data ::::', error)
            resolve(error)
        }
    })
}



export const genericApiCall =async ( apiName ,payload,url,isProtected = true)=>{
    return new Promise(async (resolve, reject) => {
       try {
            const baseUrl = isProtected ? Config.url : Config.urlOpen;

            const response = await axios.post(`${baseUrl}${apiName}`, {
                ...payload
            }, {
                headers: {
                    'Content-Type': 'application/json',
                ...(isProtected && {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                })
                }
            });
            if (response) {
                // getAlllunchAndSpacerData(1)
                     resolve(response)

            }
        } catch (error) {
            resolve([])
        }
              
              
              
            
       
        
    })
}
